var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.$store.state.settings.start_on_login_page === '0')?_c('FirstSection'):_vm._e(),(_vm.$store.state.settings.start_on_login_page === '0')?_c('SecondSection'):_vm._e(),(_vm.$store.state.settings.start_on_login_page === '1')?_c('LoginSection'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }